<template>
  <div class="row">
    <div class="col-12 d-flex align-items-center">
      <h2>AGBs</h2>
      <router-link v-if="canEdit"
                   class="btn btn-primary btn-sm ms-3"
                   :to="{name: ROUTES.GENERAL_TERMS.CREATE}">
        <i class="fas fa-file-circle-plus"/> {{ $t('general_terms.create') }}
      </router-link>
    </div>

    <div class="col-12">
      <DataTable stripedRows :lazy="true"
                 :paginator="true"
                 :rows="generalTermStore.serverOptions.rows"
                 :totalRecords="generalTermStore.itemLength"
                 dataKey="id"
                 :value="generalTermStore.general_terms"
                 :loading="generalTermStore.loading"
                 paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                 :rowsPerPageOptions="[10,20,50]"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                 @page="onPage($event)"
                 responsiveLayout="scroll">
        <TableColumn field="key" :header="$t('general_terms.key')"/>
        <TableColumn field="title" :header="$t('general_terms.title')"/>
        <TableColumn field="updated_at" :header="$t('general_terms.updated_at')">
          <template #body="{data}">
            {{ formatDate(data.updated_at, 'datetime') || '-' }}
          </template>
        </TableColumn>
        <TableColumn field="locked_at" :header="$t('general_terms.locked_at')">
          <template #body="{data}">
            {{ formatDate(data.locked_at, 'datetime') || '-' }}
          </template>
        </TableColumn>
        <TableColumn :header="$t('general_terms.operations')">
          <template #body="{data}">
            <div class="operations-wrapper">
              <router-link class="operation-item"
                           :to="{name: ROUTES.GENERAL_TERMS.SHOW, params: {id: data.id}}"
                           :title="$t('general_terms.show')">
                <i class="fas fa-eye"/>
              </router-link>
              <router-link v-if="canEdit && !data.locked_at"
                           class="operation-item"
                           :to="{name: ROUTES.GENERAL_TERMS.EDIT, params: {id: data.id}}"
                           :title="$t('general_terms.edit')">
                <i class="fas fa-edit"/>
              </router-link>
            </div>
          </template>
        </TableColumn>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {useGeneralTermStore} from "@/stores/general_term";
import {useUserStore} from "@/stores/user";
import {PERMISSIONS, ROUTES} from "@/scripts/constants";

export default {
  name: 'GeneralTermsIndex',
  setup() {
    return {
      generalTermStore: useGeneralTermStore(),
      userStore: useUserStore(),
    }
  },
  computed: {
    ROUTES() {
      return ROUTES
    },
    canEdit() {
      return this.userStore.user.hasPermission(PERMISSIONS.CONTRACTS.EDIT)
    }
  },
  created() {
    this.getGeneralTerms()
    this.setTitle('AGBs')
  },
  methods: {
    getGeneralTerms() {
      this.generalTermStore.index()
    },
    onPage(event) {
      this.generalTermStore.serverOptions = event
      this.getGeneralTerms()
    }
  }
}
</script>
